import React from 'react';
import PropTypes from 'prop-types';
import BetSlipLeg from './BetSlipLeg';
import { useDispatch, useSelector } from 'react-redux';
import { removeHorseFromBetSlip } from 'Store/actions/horseRacing/betSlipActions';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';
import CombinedHorseRow from './CombinedHorseRow';

const ContentRow = ({ selectedHorseLegs, legsData, forCouponRow, betSlipBoxTitle, isInline }) => {
  const dispatch = useDispatch();
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);
  const { combinedHorses } = useSelector(state => state.horseRacing.betSlip);


  return (
    <div className="scroll-padding">

      { programType === PROGRAM_TYPES.JOINT ? selectedHorseLegs?.map((leg, i)  => {
        return (
          <BetSlipLeg forCouponRow={ forCouponRow } leg={ leg } index={ i } key={ i }
            legData={ isInline ? legsData[0] : legsData?.find(d => d.legNo === i ) }
            betSlipBoxTitle={ betSlipBoxTitle }
            raceNumber={ isInline ? i - 1 : legsData?.findIndex(d => d.legNo === i ) }
            onHorseDelete={ horse => {
              dispatch(removeHorseFromBetSlip(i, horse));
            } } />
        );
      }) : <>
        { combinedHorses?.map((h, i) => <CombinedHorseRow item={ h } key={ h?.horse?.propositionInfo?.propositionId }/>) }
      </> }

    </div>
  );
};

ContentRow.propTypes = {
  selectedHorseLegs: PropTypes.array,
  legsData: PropTypes.array,
  forCouponRow: PropTypes.bool,
  isInline: PropTypes.bool,
  betSlipBoxTitle: PropTypes.string,
};

export default ContentRow;
